import React from 'react'
import { ContainerField, TyanLineProcessing } from '@sencha/ext-modern'

import { getMixedProps } from './blockPublic'

const LineProcessing = ({ field, /* onChange, initValues, changedValues, */defaultStyle }) => {
	const { props, rest } = getMixedProps('_lineProcessing', [defaultStyle, field])
	return <ContainerField {...props}  >
		<TyanLineProcessing errorTarget={undefined} flex={1} margin='4 0 0 8' value={rest.value} />
	</ContainerField>
}

const renderLineProcessing = config => {
	const { key } = config.field || {}
	return <LineProcessing key={key} {...config} />
}

export default renderLineProcessing